<template>
    <div class="top">
        <h1>部门{{openType}}公开报告生成系统<span v-if="port=='2617'" style="color:red">（内部预览版）</span></h1>
        <div class="icon" v-show="show">
            <router-link to="/admin/bdata" v-if="$store.state.userDetail.permissions && $store.state.userDetail.permissions.find(ele => ele == 'fd534bb776a2462b881b966a40ea3733')">
                <img src="../assets/admin.png" width="44" height="44" />
            </router-link>
            <router-link to="/config/editProject" v-if="setType">
                <img src="../assets/config.png" width="44" height="44" />
            </router-link>
            <router-link to="/divs" v-if="divListType">
                <img src="../assets/list.png" width="44" height="44" />
            </router-link>
            <el-dropdown trigger="click">
                <img src="../assets/user.png" width="44" height="44" />
                <template #dropdown>
                    <el-dropdown-menu>
                        <router-link to="/username" v-show="isshowdev">
                            <el-dropdown-item>修改单位名</el-dropdown-item>
                        </router-link>
                        <router-link to="/password">
                            <el-dropdown-item>修改密码</el-dropdown-item>
                        </router-link>
                        <router-link to="#" @click="exit">
                            <el-dropdown-item>退出管理系统</el-dropdown-item>
                        </router-link>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
    import { logout, getCookie } from "@/api/gk.js";
    export default {
        name: "top",
        props: {},
        data() {
            return {
                session: "",
                divListType: false,
                show: true,
                setType: false,
                isshowdev: true,
                openType: this.$store.state.openType == 'js' ? '决算' : '预算',
                port: window.location.port,
            };
        },
        created() {
            this.init();
            if (this.$route.name == '公开页面' || this.$route.name == '公开页面子页面') {
                this.show = false
            }
            setTimeout(() => {
                if (localStorage.getItem('divListType')) {
                    this.divListType = true;
                } else {
                    this.divListType = false;
                }
                if (localStorage.getItem('setType')) {
                    this.setType = true;
                } else {
                    this.setType = false;
                }
            }, 100);

        },
        methods: {
            /**
             * 跳转到部门时间页面
             */
            async init() {
                let href = window.location.host;
                let prefix = href.slice(0, href.indexOf("."));
                if (prefix == "linqing" && href.split(".")[1] != "22ys") {
                    this.isshowdev = false;
                }
            },
            async exit() {
                this.$message("退出登录");
                this.session = getCookie("session");
                let res = await logout({ session: this.session });

                //根据返回的结果做跳转
                if (window.location.host.indexOf('localhost') !== -1) {
                    this.$cookies.remove("session");
                } else {
                    var url = (document.domain).split(".");
                    var arrUrl = '.' + url[2] + '.' + url[3]
                    this.$cookies.remove("session", '/', arrUrl);
                }
                this.$cookies.remove("zone");
                setTimeout(() => {
                    this.$router.push({ name: 'login' })
                    this.$cookies.remove("district");
                }, 500)
                //跳转到登陆页面
                addTitle()
            },
        },
    };
</script>
<style scoped>
    * {
        text-decoration: none;
    }

    .top {
        height: 80px !important;
        background-image: url(../assets/top.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
    }

        .top h1 {
            width: calc(100% - 340px);
            margin: 0px;
            padding: 0px;
            line-height: 76px;
            color: #fff;
            letter-spacing: 2px;
            padding-left: 20px;
            float: left;
        }

    .icon {
        float: right;
        margin-right: 20px;
        margin-top: 10px;
    }

        .icon a {
            width: 60px;
            height: 60px;
            padding: inherit;
            display: inline-block;
            cursor: pointer;
            text-align: center;
            margin: 0 3px;
            -webkit-transition: 0.1s;
            transition: 0.1s;
            border-radius: 4px;
            background: #e5f2ff !important;
            border-color: #e5f2ff !important;
            box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12);
        }

            .icon a img {
                line-height: 60px;
                padding-top: 8px;
            }
</style>